import {
  localizationLanguageApi,
  localizationStringApi,
  posConfigurationApi,
} from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOCALIZATION_STRINGS_ACTION_TYPE = createNamedActions('localizationStrings', {
  GET_LIST: 'GET_LIST',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  GET_LANGUAGES: 'GET_LANGUAGES',
  SET_LANGUAGE_CODE: 'SET_LANGUAGE_CODE',
  GET_ENABLED_STEP_KEYS: 'GET_ENABLED_STEP_KEYS',
});

export const getLocalizationStringsAction = catchAsyncActionError(
  ({ languageCode, posConfigurationId, category } = {}) =>
    async dispatch => {
      const { data } = await localizationStringApi.getLocalizationStrings({
        languageCode,
        posConfigurationId,
        category,
      });

      return dispatch({
        type: LOCALIZATION_STRINGS_ACTION_TYPE.GET_LIST,
        payload: { items: data, languageCode },
      });
    },
);

export const updateLocalizationStringAction = catchAsyncActionError(
  ({ id, ...body }) =>
    async dispatch => {
      const { data } = await localizationStringApi.updateLocalizationString({ id, ...body });

      return dispatch({
        type: LOCALIZATION_STRINGS_ACTION_TYPE.UPDATE,
        payload: { item: data, originalId: id },
      });
    },
);

export const deleteLocalizationStringAction = catchAsyncActionError(
  ({ id, languageCode, posConfigurationId }) =>
    async dispatch => {
      await localizationStringApi.deleteLocalizationString({ id });

      dispatch({
        type: LOCALIZATION_STRINGS_ACTION_TYPE.DELETE,
        payload: { id },
      });

      return dispatch(getLocalizationStringsAction({ languageCode, posConfigurationId }));
    },
);

export const getLocalizationLanguagesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await localizationLanguageApi.getActiveLocalizationLanguages();

  return dispatch({
    type: LOCALIZATION_STRINGS_ACTION_TYPE.GET_LANGUAGES,
    payload: data,
  });
});

export const setLocalizationStringsLanguageAction = languageCode => ({
  type: LOCALIZATION_STRINGS_ACTION_TYPE.SET_LANGUAGE_CODE,
  payload: { languageCode },
});

export const getEnabledStepKeysAction = catchAsyncActionError(
  ({ posConfigurationId }) =>
    async dispatch => {
      const { data } = await posConfigurationApi.getEnabledStepKeys({ id: posConfigurationId });

      return dispatch({
        type: LOCALIZATION_STRINGS_ACTION_TYPE.GET_ENABLED_STEP_KEYS,
        payload: data,
      });
    },
);
